
import React from 'react';

interface HeaderProps {
  title: string;
  children?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ title, children }) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
      <h1 className="text-3xl font-bold text-gray-800 dark:text-white mb-4 md:mb-0">
        {title}
      </h1>
      <div className="flex items-center space-x-2">
        {children}
      </div>
    </div>
  );
};

export default Header;
